// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'column-delete';

export const Component = () => (
  <path d='M11.345 17.776s-.527-.176-.527-.527V7.527c0-.351.176-.526.527-.526.32 0 .478.176.478.526v9.722c0 .352-.159.527-.478.527Zm1.484-10.25s.16-.526.479-.526c.32 0 .479.176.479.527v9.721c0 .352-.16.527-.48.527-.319 0-.478-.176-.478-.527V7.527Zm-7.71 2.3s-.144-.208-.144-.335c0-.352.16-.527.479-.527.032 0 .144.048.335.144l2.921 2.97a.46.46 0 0 1 0 .67l-2.92 2.97c-.192.095-.304.143-.336.143-.32 0-.479-.176-.479-.527A.46.46 0 0 1 5.119 15l2.107-2.107h-5.7c-.351 0-.526-.16-.526-.479 0-.32.176-.479.527-.479h5.699L5.119 9.827v-.001Zm14.415 5.172a.46.46 0 0 1 .144.335c0 .351-.16.526-.479.526-.064 0-.191-.047-.383-.143l-2.92-2.97a.46.46 0 0 1 0-.67l2.92-2.97a.517.517 0 0 1 .383-.143c.32 0 .48.159.48.478 0 .16-.049.288-.145.383l-2.107 2.107h5.7c.32 0 .478.16.478.48 0 .319-.159.478-.478.478h-5.7l2.107 2.107v.002Z' />
);

export const viewBox = '0 0 25 25';
